// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface MigrateRasterColormapRangeRequest {
  /**
   *
   */
  tenantId: string;
}

export interface MigrateRasterPhysicalQuantityStyleRequest {
  /**
   *
   */
  tenantId: string;
}

export interface MigrateStudyAreaInversePmtilesViewRequest {
  /**
   *
   */
  tenantId: string;
}

/**
 *
 */
export class MigrationApi extends runtime.BaseAPI {
  /**
   * Creates request options for migrateRasterColormapRange without sending the request
   */
  async migrateRasterColormapRangeRequestOpts(
    requestParameters: MigrateRasterColormapRangeRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling migrateRasterColormapRange().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/migrations/raster-colormap-range`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * One-time migration: for every completed raster file descriptor that has a custom style_id set, reads its colormap.json from S3 and writes the value range into the Lizard raster layer options.styles string (e.g. ``RANA_STYLE__<id>:<min>:<max>`` for gradient colormaps, ``RANA_STYLE__<id>`` for discrete colormaps). Safe to re-run.
   * Sync raster colormap ranges to Lizard raster layers
   */
  async migrateRasterColormapRangeRaw(
    requestParameters: MigrateRasterColormapRangeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.migrateRasterColormapRangeRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * One-time migration: for every completed raster file descriptor that has a custom style_id set, reads its colormap.json from S3 and writes the value range into the Lizard raster layer options.styles string (e.g. ``RANA_STYLE__<id>:<min>:<max>`` for gradient colormaps, ``RANA_STYLE__<id>`` for discrete colormaps). Safe to re-run.
   * Sync raster colormap ranges to Lizard raster layers
   */
  async migrateRasterColormapRange(
    requestParameters: MigrateRasterColormapRangeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.migrateRasterColormapRangeRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for migrateRasterPhysicalQuantityStyle without sending the request
   */
  async migrateRasterPhysicalQuantityStyleRequestOpts(
    requestParameters: MigrateRasterPhysicalQuantityStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling migrateRasterPhysicalQuantityStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/migrations/raster-physical-quantity-style`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * One-time migration: for every raster file descriptor with a registered physical quantity but no style_id, derives and stores the matching style. Safe to re-run.
   * Backfill raster styles from physical quantities
   */
  async migrateRasterPhysicalQuantityStyleRaw(
    requestParameters: MigrateRasterPhysicalQuantityStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.migrateRasterPhysicalQuantityStyleRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * One-time migration: for every raster file descriptor with a registered physical quantity but no style_id, derives and stores the matching style. Safe to re-run.
   * Backfill raster styles from physical quantities
   */
  async migrateRasterPhysicalQuantityStyle(
    requestParameters: MigrateRasterPhysicalQuantityStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.migrateRasterPhysicalQuantityStyleRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for migrateStudyAreaInversePmtilesView without sending the request
   */
  async migrateStudyAreaInversePmtilesViewRequestOpts(
    requestParameters: MigrateStudyAreaInversePmtilesViewRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling migrateStudyAreaInversePmtilesView().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/migrations/study-area-inverse-pmtiles`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * One-time migration: for every completed study area vector that has no custom ``style_id`` and no ``presentation`` override in its ``user_supplied_meta``, sets ``presentation.view = inverse-pmtiles`` and queues a reprocessing job so the backend generates the inverse PMTiles mask file in S3. Safe to re-run.
   * Set inverse-pmtiles presentation and reprocess study area vectors
   */
  async migrateStudyAreaInversePmtilesViewRaw(
    requestParameters: MigrateStudyAreaInversePmtilesViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.migrateStudyAreaInversePmtilesViewRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * One-time migration: for every completed study area vector that has no custom ``style_id`` and no ``presentation`` override in its ``user_supplied_meta``, sets ``presentation.view = inverse-pmtiles`` and queues a reprocessing job so the backend generates the inverse PMTiles mask file in S3. Safe to re-run.
   * Set inverse-pmtiles presentation and reprocess study area vectors
   */
  async migrateStudyAreaInversePmtilesView(
    requestParameters: MigrateStudyAreaInversePmtilesViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.migrateStudyAreaInversePmtilesViewRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
